export default __webpack_public_path__ + "2a52f7498d92ac547480a8f3046cb6b1.png";